import {
    Component,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    EventEmitter,
    Output,
    Input,
} from '@angular/core';

@Component({
    selector: 'mapp-succes-error-box',
    templateUrl: './success-error-box.component.html',
    styleUrls: ['./success-error-box.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export default class SuccessErrorBoxComponent {
    @Output() onFirstButtonClick: EventEmitter<any> = new EventEmitter<any>();

    @Output() onSecondButtonClick: EventEmitter<any> = new EventEmitter<any>();

    @Input() firstButtonText: string;

    @Input() secondButtonText: string;

    @Input() icon: string;

    @Input() title: string;

    @Input() description: string;
}
